import cx from 'classnames';
import ProductPrice, { ProductPricePlaceholder } from 'mk2/apps/bazaar/components/ProductPrice';
import { ProductEntity } from 'mk2/apps/bazaar/schemas';
import { ImgResponsive } from 'mk2/components/ImgResponsive';
import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './GridItemPhoto.mscss';

interface OwnProps {
    className?: string;
    product: ProductEntity;
}

type Props = OwnProps;

const GridItemPhoto: React.FunctionComponent<Props> = ({ className, product }) => {
    return (
        <div className={cx(styles.GridItemPhoto, className)}>
            <div className={styles.GridItemPhoto__box}>
                <ImgResponsive
                    key={(product.photos?.[0]?.photofile).code}
                    photo={product.photos?.[0]?.photofile}
                    photoVersion={largestAvailablePhotoVersionOfBazaar(product.photos[0].photofile)}
                    alt={product.seo.name}
                />
                <ProductPrice
                    className={styles.GridItemPhoto__price}
                    price={product.price}
                    priceOld={product.priceOld}
                    isReserved={false}
                />
            </div>
        </div>
    );
};

GridItemPhoto.displayName = 'GridItemPhoto';

export function largestAvailablePhotoVersionOfBazaar(photo: PhotoEntity): string {

    if (photo.versions.includes('s440x440')){
        return 's440x440';
    }
    else return 's221x221';

}

export default React.memo<Props>(GridItemPhoto);

interface PlaceholderOwnProps {
    className?: string;
}

let GridItemPhotoPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({ className }) => (
    <div className={cx(styles.GridItemPhoto, className)}>
        <div className={styles.GridItemPhoto__box}>
            <LoadingPlaceholder width={221} height={221} />
            <ProductPricePlaceholder className={styles.GridItemPhoto__price} />
        </div>
    </div>
);

GridItemPhotoPlaceholder.displayName = 'GridItemPhotoPlaceholder';

GridItemPhotoPlaceholder = React.memo<PlaceholderOwnProps>(GridItemPhotoPlaceholder);

export { GridItemPhotoPlaceholder };
